import {
  MAX_FILE_SIZE,
  CONTEXT_SIZE_OVERRIDES,
  getMaxFileSize,
  formatFileSize,
} from '@shared/uploadConfig';

export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / 1024 / 1024; // 60
export const EMAIL_ATTACHMENT_MAX_MB = CONTEXT_SIZE_OVERRIDES.emailAttach / 1024 / 1024; // 25
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE;
export const EMAIL_ATTACHMENT_MAX_BYTES = CONTEXT_SIZE_OVERRIDES.emailAttach;

export { formatFileSize, getMaxFileSize };

export function validateEmailAttachments(files: File[]): { valid: File[]; oversized: string[] } {
  const valid: File[] = [];
  const oversized: string[] = [];
  for (const f of files) {
    if (f.size <= EMAIL_ATTACHMENT_MAX_BYTES) valid.push(f);
    else oversized.push(f.name);
  }
  return { valid, oversized };
}

/**
 * Validates if a file's size is within the allowed limit.
 */
export const isFileSizeValid = (file: File, maxSizeInBytes: number = MAX_FILE_SIZE_BYTES): boolean => {
  return file.size <= maxSizeInBytes;
};
